import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.MatrixPopupContent.AllowEditingCell', {
    allowToEditThisField: 'Allow to edit this field',
    anyField: 'Any {fieldName}',
    canChangeFieldTo: 'Can change {fieldName} to',
    cannotChangeFieldTo: 'Cannot change {fieldName} to',
});
